<script lang="ts">
	import { page } from '$app/state';
	import { getAndroidArLink } from '$lib/utils/ar';
	import BtnPrimary from './btnPrimary.svelte';
	import type { BtnSize, BtnTheme } from './types';
	import { getArFiles } from '$lib/api/arFiles';
	import { type Snippet } from 'svelte';
	import { device } from '$lib/state/device.svelte';

	interface Props {
		btn?: HTMLAnchorElement | HTMLButtonElement | undefined;
		size?: BtnSize;
		theme?: BtnTheme;
		[key: string]: any;
		children?: Snippet;
	}

	let {
		btn = $bindable(),
		size = 'regular',
		theme = 'default',
		children,
		...other
	}: Props = $props();

	const arFiles = getArFiles();
</script>

{#await arFiles then files}
	{#if device.data.os.name === 'iOS'}
		<BtnPrimary {size} {theme} bind:btn rel="ar" href={files.iosUrl} {...other}
			>{@render children?.()}</BtnPrimary
		>
	{:else}
		<BtnPrimary
			{size}
			{theme}
			bind:btn
			href={getAndroidArLink(files.androidUrl, {
				title: 'Mill kitchen bin',
				fallbackUrl: page.url.origin + page.url.pathname
			})}
			{...other}>{@render children?.()}</BtnPrimary
		>
	{/if}
{/await}
